var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFurniture = function SvgIconFurniture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M7.5 25.246h-3V7.006h24v18.24h-3m-18 0h18m-18 0v-11.36m18 11.36v-11.36m0 0v-3.88h-18v3.88m18 0h-18"
  })));
};
export { SvgIconFurniture as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAzMiAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNSAyNS4yNDU5SDQuNVY3LjAwNTg2SDI4LjVWMjUuMjQ1OUgyNS41TTcuNSAyNS4yNDU5SDI1LjVNNy41IDI1LjI0NTlWMTMuODg1OU0yNS41IDI1LjI0NTlWMTMuODg1OU0yNS41IDEzLjg4NTlWMTAuMDA1OUg3LjVWMTMuODg1OU0yNS41IDEzLjg4NTlINy41IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjgiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";